import { render, staticRenderFns } from "./group-details.vue?vue&type=template&id=648982c6&lang=pug&"
import script from "./group-details.vue?vue&type=script&lang=js&"
export * from "./group-details.vue?vue&type=script&lang=js&"
import style0 from "./group-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports